export default "__VITE_ASSET__B$Ys2FiA__"